
async function loadData(url) {
    try {
      let response = await fetch(url);
      let responseJson = await response.json();
      return responseJson;
     } catch(error) {
      console.error(error);
    }
  }

export default loadData